<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <service-agreement-form
      :onSubmit="onSubmit"
      :isLoading="isLoading"
    ></service-agreement-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ServiceAgreementForm from './ServiceAgreementForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { documentRegistry } = services;
const { serviceAgreementService } = documentRegistry;

export default {
  name: 'ServiceAgreementCreate',
  components: {
    ServiceAgreementForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Service Agreement Create',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      try {
        const serviceAgreementData = {
          name: data.name,
          description: data.description,
        };
        this.isLoading = true;

        const serviceAgreement = await serviceAgreementService
          .create({ serviceAgreement: serviceAgreementData });

        const { _id } = serviceAgreement;

        const formData = new FormData();
        formData.append('attachment', data.attachment[0]);
        await serviceAgreementService.upload({ id: _id, formData });

        this.isLoading = false;

        this.$snackbar.showOk({ text: 'Successfully created service agreement!' });

        this.$router.push({ name: 'service-agreement.list' });
      } catch (e) {
        this.isLoading = false;
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
    },
  },
};
</script>
